import React from 'react';
import PropTypes from 'prop-types';
import { TrashIcon } from '@heroicons/react/24/outline';
import { useQueryMutation } from '@lore/query-connect';
import { useQueryClient } from '@tanstack/react-query';
import classNames from 'classnames';
import Resource from '../../../components_profiles/Resource';

UploadDocumentDestroyable.propTypes = {
  upload: PropTypes.object
};

export default function UploadDocumentDestroyable(props) {
  const { upload } = props;

  const queryClient = useQueryClient();

  const mutation = useQueryMutation('upload.destroy', upload);
  const { saving, success, error, request } = mutation;

  function onDestroy() {
    mutation.mutate(null, {
      onSuccess: function() {
        queryClient.invalidateQueries({ queryKey: ['upload', 'find'] });
      }
    });
  }

  return (
    <div className={classNames(
      'relative',
      saving && 'opacity-50'
    )}>
      <Resource
        title={upload.data.name}
        description={upload.data.description}
        url={upload.data.url}
      />
      <div className="absolute top-1.5 right-2">
        <div
          className="p-1 bg-white xbg-cs-gray-100 border border-cs-gray-500 rounded-full opacity-60 hover:opacity-100 hover:bg-cs-gray-200 cursor-pointer"
          onClick={onDestroy}
        >
          <TrashIcon className="h-5 w-5 text-cs-gray-500" />
        </div>
      </div>
    </div>
  );
}
